<template>
    <div>
        <div>
            <el-button type="primary" @click="show = true">新增</el-button>
            <el-button type="danger" @click="deleteFunc">删除</el-button>
        </div>

        <div class="common-table">
            <el-table v-loading="loading" :data="hotClubList.beanList" row-key="id" height="100%"
                      @selection-change="selectionChange">
                <el-table-column type="selection" width="55"/>
                <el-table-column label="编号" type="index" align="center"/>
                <el-table-column label="用户ID" width="120" align="center" prop="creatorId"/>
                <el-table-column label="用户昵称" width="150" align="center" prop="creatorName"/>
                <el-table-column label="俱乐部昵称" width="180" align="center" prop="clubName"/>
                <el-table-column label="俱乐部ID" align="center" prop="randomId"/>
                <el-table-column label="基金仓" align="center" prop="fund"/>
                <el-table-column label="推广员数量" width="100" align="center" prop="promoterNumbers"/>
                <el-table-column label="分成比例" align="center">
                    <template slot-scope="scope">{{scope.row.profit}}%</template>
                </el-table-column>
                <el-table-column label="联系方式" width="150" align="center" prop="contact"/>
                <el-table-column label="联盟" align="center" prop="tribeName"/>
                <el-table-column label="操作" width="250" align="center">
                    <template slot-scope="scope">
                        <el-button size="mini" type="success" @click="updateOrder(scope.row.id,1)">上移</el-button>
                        <el-button size="mini" type="primary" @click="updateOrder(scope.row.id,0)">下移</el-button>
                        <el-button size="mini" type="danger" @click="updateOrder(scope.row.id,2)">置顶</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>

        <el-pagination
                class="common-el-pagination"
                layout="prev,pager,next,jumper"
                background
                :page-size="20"
                :pager-count="5"
                :total="hotClubList.total"
                :current-page="currentPage"
                @current-change="getList({page:$event})"/>

        <div v-if="show" class="common-popup-bg">
            <div class="common-popup">
                <i class="common-popup-close el-icon-close" @click="closeAdd"></i>
                <h3>俱乐部列表</h3>
                <div class="block">
                    <div>
                        <el-input
                                class="common-el-input"
                                placeholder="输入俱乐部昵称或ID查询"
                                v-model="searchVal">
                            <i slot="prefix" class="el-input__icon el-icon-search"></i>
                        </el-input>
                        <el-button type="primary" @click="getCanSetList()">搜索</el-button>
                    </div>

                    <el-table
                            v-loading="loading_set"
                            style="min-height: auto"
                            class="common-table"
                            height="100%"
                            row-key="id"
                            :data="canSetHotClub.beanList"
                            @selection-change="selectionChange_set">
                        <el-table-column type="selection" width="55"/>
                        <el-table-column label="俱乐部昵称" align="center" prop="clubName"/>
                        <el-table-column label="俱乐部ID" align="center" prop="randomId"/>
                        <el-table-column label="所属联盟" align="center" prop="tribeName"/>
                        <el-table-column label="创建者ID" align="center" prop="creatorId"/>
                        <el-table-column label="创建者昵称" align="center" prop="creatorName"/>
                    </el-table>
                    <el-pagination
                            class="common-el-pagination"
                            style="padding-top: 10px !important;"
                            layout="prev,pager,next,jumper"
                            background
                            :page-size="20"
                            :pager-count="5"
                            :total="canSetHotClub.total"
                            :current-page="currentPage"
                            @current-change="getCanSetList({page:$event})"/>
                </div>
                <footer>
                    <el-button size="small" @click="closeAdd">取消</el-button>
                    <el-button size="small" type="primary" @click="addHotClubs">确定</el-button>
                </footer>
            </div>
        </div>
    </div>
</template>
<script>
    import {mapState, mapActions} from 'vuex'

    export default {
        data() {
            return {
                loading: false,
                currentPage: 1,
                selectClubIds: [],
                show: false,
                loading_set: false,// 可推荐列表loading
                searchVal: '',// 搜索可设置成推荐的俱乐部
                selectClubIds_set: [],
            }
        },
        computed: {
            ...mapState('club', ['hotClubList', 'canSetHotClub']),
        },
        created() {
            this.getList()
        },
        methods: {
            ...mapActions('club', ['getHotClubList', 'deleteHotClub', 'getCanSetHotClub', 'addHotClub', 'updateHotClub']),
            // 推荐俱乐部列表
            getList(obj = {}) {
                this.loading = true;
                let params = {
                    page: 1,
                };
                Object.assign(params, obj);

                this.currentPage = params.page;
                this.getHotClubList(params).then(() => {
                    this.loading = false;
                    if (this.currentPage !== 1 && !this.canSetHotClub.beanList.length) {
                        this.getList({page: this.currentPage - 1})
                    }
                })
            },
            selectionChange(value) {
                this.selectClubIds = value.map(v => v.clubId)
            },
            deleteFunc() {
                if (!this.selectClubIds.length) {
                    this.$message.info('请选择要删除的推荐俱乐部');
                    return;
                }
                this.$confirm('您确定要删除选中的俱乐部吗？删除后APP端推荐俱乐部列表将不再显示该俱乐部', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.deleteHotClub({
                        clubList: this.selectClubIds
                    }).then(() => {
                        this.$message.success('删除成功');
                        this.getList(this.currentPage);
                    })
                }).catch(() => {
                });
            },
            // 调整位置
            updateOrder(id, op) {
                this.loading = true;
                this.updateHotClub({id, op}).then(() => {
                    this.getList({page: this.currentPage})
                })
            },
            // 可推荐俱乐部列表
            getCanSetList(obj = {}) {
                this.loading_set = true;
                let params = {
                    key: this.searchVal,
                    page: 1,
                    statu: '',
                    userType: ''
                };
                Object.assign(params, obj);
                this.getCanSetHotClub(params).then(() => {
                    this.loading_set = false;
                })
            },
            selectionChange_set(value) {
                this.selectClubIds_set = value.map(v => v.id)
            },
            addHotClubs() {
                if (!this.selectClubIds_set.length) {
                    this.$message.info('未选择');
                    return;
                }
                this.addHotClub({clubList: this.selectClubIds_set}).then(() => {
                    this.$message.success('添加成功');
                    this.getList({page: this.currentPage})
                })
            },
            closeAdd() {
                this.show = false
            }
        }
    }
</script>
<style lang="scss" scoped>
    .block {
        position: relative;
        display: flex;
        flex-flow: column;
        width: 700px;
        height: 50vh;
        min-height: 400px;
        padding: 10px 20px;
    }

    .common-popup :global(table) {
        padding: 0;
    }
</style>